import { OnDestroy } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { Paginator } from 'primeng/paginator';
import { SortValues } from '@app/shared/constants/app.constants';
import { NickNameModalService } from '@app/feature/main/roles-shared/services/nick-name-modal.service';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { MarketDataDetailsService } from '@app/feature/main/roles-shared/services/market-data-details.service';
import { Router, NavigationExtras } from '@angular/router';
import { DataService } from '@app/feature/main/roles-shared/services/data.service';
import { CommentModalService } from '@app/shared/services/comment-modal.service';
import swal from "sweetalert2";
import * as _ from 'lodash';
import { BreadcrumService } from '@app/shared/services/breadcrum.service';
import { LikeModalServiceService } from '@app/shared/services/like-modal-service.service';
@Component({
  selector: 'app-bookmarked-item-list',
  templateUrl: './bookmarked-item-list.component.html',
  styleUrls: ['./bookmarked-item-list.component.css']
})
export class BookmarkedItemListComponent implements OnInit,OnDestroy {

  @ViewChild('paginatorId') paginator = new Paginator();

  userDetailsObject: any;
  userId: any;
  totalRecords = 0;
  dataLimit = 9;
  skipValue = 0;
  selectedDomain = "";
  searchString;
  techDomainListselected = null;
  sortSelectedindex = null;
  sortListData: any;
  techDomainListData: any;
  noResearchData: boolean;
  bookmarkedItemList: any = [];
  bookmarkSelectedItem: string = 'report';
  userRole: any;
  filter: any = {};
  isActiveID: string;

  constructor(
    private rolesSharedService: RolesSharedService,
    private nickNameModalService: NickNameModalService,
    private authenticationService: AuthenticationService,
    private marketDataDetailsService: MarketDataDetailsService,
    private dataService: DataService,
    private breadcrumService:BreadcrumService,
    private router: Router,
    private likeModalService: LikeModalServiceService,
    private commentModalService: CommentModalService
  ) { }

  ngOnInit() {
    this.getDomainList();
    this.getBookmarkList();
    this.getRole();
    this.userDetails();
    this.sortListData = SortValues.list;
     const tempSession = sessionStorage.getItem('userDetails');
     localStorage.setItem('tempSession',tempSession);
  }
  routeTechAnalystProfilePage(analystId: string, firstName, lastName) {
    this.breadcrumService.setUrl('BC3Label', firstName + ' ' + lastName);
    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } })
  }
  getHrefAnalystUrl(analystId: string, firstName, lastName) {
    this.breadcrumService.setUrl('BC3Label', firstName + ' ' + lastName);
    return `${document.location.origin}/#/analyst-profile?analystId=${analystId}`;
  }
  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }
  ngOnDestroy(): void {
    
  }
  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
    }
  }

  getDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe(data => {

      this.techDomainListData = data;
    });
  }

  getBookmarkFilter() {
   // const filter: any = {};
    // this.filter.filter = JSON.stringify({
    //   include: [{
    //     researchDocument: [
    //       {
    //         likes: "user"
    //       }, {
    //         comments: "user"
    //       },
    //       {
    //         ratings: "user"
    //       }]
    //   }, {
    //     marketData: [
    //       {
    //         likes: "user"
    //       },
    //       {
    //         comments: "user"
    //       }
    //     ]
    //   }]
    // });
    this.filter.limit = this.dataLimit;
    this.filter.skip = this.skipValue;
    this.filter.type = this.bookmarkSelectedItem;
    if (this.searchString) {
      this.filter.search = JSON.stringify(this.searchString);
    }
    if (this.sortSelectedindex) {
      this.filter.sort = JSON.stringify(this.sortSelectedindex);
    }
    if (this.techDomainListselected) {
      this.filter.where = JSON.stringify({
        techDomainId: this.techDomainListselected
      });
    }

    return this.filter;
  }

  getBookmarkList() {
    this.rolesSharedService.getBookMarkList(this.getBookmarkFilter()).subscribe((response: any) => {
      let responseData = [];
      responseData = response.data.filter(
        bookmark => bookmark.postType === this.bookmarkSelectedItem);
      this.bookmarkedItemList = _.uniqWith([...this.bookmarkedItemList, ...responseData], _.isEqual);
      this.totalRecords = this.getBookmarkList.length;
    });
  }

  applyFilter() {
    this.dataLimit = 9;
    this.skipValue = 0;
    if (this.paginator) {
      this.paginator.first = 0;
    }
    this.getBookmarkList();
  }
  onScrollDown() {
    if (this.bookmarkedItemList.length > 0) {
      this.skipValue = this.skipValue + 9;
      if (this.paginator) {
        this.paginator.first = 0;
      }
        this.getBookmarkList();
    }
  }

  resetScroll() {
    this.dataLimit = 9;
    this.skipValue = 0;
    this.bookmarkedItemList = [];
    this.getBookmarkList();
  }

  paginate(event: any) {
    this.dataLimit = event.rows;
    this.skipValue = event.first;
    this.getBookmarkList();
  }

  researchLikeClick(postData: any) {
    if (this.userDetailsObject.nickName) {
      // like button click
      const likeObject = {
        postId: postData.id,
        postType: "research_document",
        userId: this.userId
      };

      this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
        if (likeResponse["liked"]) {
          postData.liked = true;
          postData.likes += 1;
        } else if (!likeResponse["liked"]) {
          postData.liked = false;
          if (postData.likes != 0) {
            postData.likes -= 1;
          }
        }
      })
    } else {

      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      })
    }
  }

  marketDataLikeClick(postData: any) {
    if (this.userDetailsObject.nickName) {
      // like button click
      const likeObject = {
        postId: postData.id,
        postType: "market_data",
        userId: this.userId
      };

      this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
        if (likeResponse["liked"]) {
          postData.liked = true;
          postData.likes += 1;
        } else if (!likeResponse["liked"]) {
          postData.liked = false;
          if (postData.likes != 0) {
            postData.likes -= 1;
          }
        }
      })
    } else {

      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      })
    }
  }

  openCommentModal(data: any , postType: string) {
    if (postType === "market_data"){
      data.postType = postType;
    }
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.userDetailsObject.nickName) {
        this.commentModalService.modalStatus(true, data);
      }
      else {
        this.nickNameModalService.openNickNameModal();
      }
    }
  }

  populateComments(data: any , postType?: string) {
    if (postType === "market_data") {
      data.postType = postType;
    }
    if (this.userDetailsObject.nickName) {
      data.showComments = !data.showComments;
      this.isActiveID = data.id;
    } else {
      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      });
    }
  }

  openLikeModal(data) {
    this.likeModalService.modalStatus(true, data);
  }

  clickMarketData(bookmarkedItem: any) {
    const researchDataId = bookmarkedItem.marketData.researchDocument[0].id;
    const marketDataId = bookmarkedItem.marketData.id;
    const techDomainId = bookmarkedItem.marketData.researchDocument[0].techDomainId;
    this.breadcrumService.setUrl('BC3Label', bookmarkedItem.marketData.title);
    bookmarkedItem[`researchDataId`] = researchDataId;
    // Fetch and store userFilteredData which is already applied for marketData
    // while bookmark is done & then redirect to market-data-details page
    const userFilteredData = this.marketDataDetailsService.fetchUserFilteredData(bookmarkedItem);
    this.marketDataDetailsService.setUserFilteredData(userFilteredData);
    sessionStorage.setItem("bookmarkedTechDomain" , techDomainId );
    const  solutionFilter ={
      techDomainId: techDomainId
    };
    this.rolesSharedService.getSolutionFilter(solutionFilter).subscribe((response)=>{
      sessionStorage.setItem("bookmarkedSolution", JSON.stringify(response['data']));
    })
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "bookmarkedTechDomain" : techDomainId
      }
    }
    this.router.navigate([`${this.userRole}/market-data-details/${researchDataId}/${marketDataId}`], navigationExtras);
  }

  getHrefUrlMarketData(bookmarkedItem: any) {
    if(bookmarkedItem.marketData && bookmarkedItem.marketData.researchDocument && bookmarkedItem.marketData.researchDocument[0].id){
    const researchDataId =  bookmarkedItem.marketData && bookmarkedItem.marketData.researchDocument && bookmarkedItem.marketData.researchDocument[0].id;
    const marketDataId = bookmarkedItem.marketData.id;
    return `${document.location.origin}/#/${this.userRole}/market-data-details/${researchDataId}/${marketDataId}`;
    }else{
      return '#'
    }
  }


  isAccessible(id: string, title) {
    this.breadcrumService.setUrl('BC3Label', title);

    // sessionStorage.setItem('reportTitle', title);
    // sessionStorage.setItem('reportPage', 'All Bookmarks');
    // sessionStorage.setItem('reportLink', `${this.userRole}/my-bookmarks`);
    if (this.userRole === "tech-analyst") {
      this.router.navigate([`${this.userRole}/reports/report-details/${id}`]);
    } else {
      this.router.navigate([`${this.userRole}/report-details/${id}`]);
    }
  }
  getHrefUrl(id: string, title){
    if (this.userRole === "tech-analyst") {
      return `${document.location.origin}/#/${this.userRole}/reports/report-details/${id}`;
    } else {
      return `${document.location.origin}/#/${this.userRole}/report-details/${id}`;
    }
  }

  clickResearchDocument(bookmarkedItem: any) {
    this.dataService.researchDocumentDataService(bookmarkedItem.researchDocument);
    if (this.userRole === 'tech-vendor') {
      this.router.navigate([`${this.userRole}/market-data/${bookmarkedItem.researchDocument.id}`]);
    } else {
      this.router.navigate([`${this.userRole}/research-snapshot/${bookmarkedItem.researchDocument.id}`]);
    }
  }

  getHrefUrlRD(bookmarkedItem: any) {
    this.dataService.researchDocumentDataService(bookmarkedItem.researchDocument);
    if (this.userRole === 'tech-vendor') {
      return `${document.location.origin}/#/${this.userRole}/market-data/${bookmarkedItem.researchDocument.id}`;
    } else {
      return `${document.location.origin}/#/${this.userRole}/research-snapshot/${bookmarkedItem.researchDocument.id}`;
    }
  }
  unBookmark(data: any, type: string) {
    const bookmarkData: any = {};
    if (data.id) {
      bookmarkData.bookmarkId = data.id;;
    }
    bookmarkData.postId = data.postId;
    bookmarkData.postType = type;
    this.rolesSharedService.bookmark(bookmarkData).subscribe(
      (response: any) => {
        data.bookmarked = true;
        this.resetScroll();
        swal({
          position: "center",
          type: "success",
          title: "Bookmark removed successfully",
          showConfirmButton: false,
          timer: 1000
          // text: "Bookmarked"
        });
      },
      error => { }
    );
  }

  likeClick(postData: any) {
    if (this.userDetailsObject.nickName) {
      const likeObject = {
        postId: postData.id,
        postType: "report",
        userId: this.userId
      };
      this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
        if (likeResponse["liked"]) {
          this.rolesSharedService.logLikeInMixpanel(likeObject.postType, postData.title);
          // case when user is liked and updated in server
          postData.liked = true;
          postData.likes += 1;
        } else if (!likeResponse["liked"]) {
          // case when user is not liked and updated in server
          postData.liked = false;
          if (postData.likes != 0) {
            postData.likes -= 1;
          }
        }
      });
    } else {
      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe(
        (response: any) => {
          if (response) {
            this.userDetails();
          }
        }
      );
    }
  }

  reportOpenCommentModal(data) {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.userDetailsObject.nickName) {
        this.commentModalService.modalStatus(true, data);
      } else {
        this.nickNameModalService.openNickNameModal();
      }
    }
  }

  navtoReportsList() {
    this.router.navigate(["reports"]);
  }

  navtoResearchList() {
    if(this.userRole === 'tech-vendor') {
      this.router.navigate(["all-market-data"]);
    } else {
      this.router.navigate(["research/all-research"]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/bookmarked-item-list/bookmarked-item-list.component.ts